import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface adminState {
    activeMenu: string;
    isAdminLoadershow: boolean;
}
const initialState: adminState = {
    activeMenu: 'variationMapping',
    isAdminLoadershow: false,
};

const adminMenuSlice = createSlice({
    name: 'AdminPageMenuSlice',
    initialState,
    reducers: {
        changeActiveMenu: (state, action: PayloadAction<string>) => {
            state.activeMenu = action.payload;
        },
        setAdminLoaderShow: (state, action: PayloadAction<boolean>) => {
            state.isAdminLoadershow = action.payload;
        },
    },
});

export const { changeActiveMenu, setAdminLoaderShow } = adminMenuSlice.actions;
export default adminMenuSlice.reducer;
